import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../builder';
import { HeadingLevel } from './HeadingLevel';

export default createBuilderModule(withChildren(HeadingLevel), {
  name: 'HeadingLevel',
  image: 'https://cdn.zappy.app/27e375dc0c0b465ac8b8b1bf5b63837d.png',
  inputs: [],
});
